import { Link } from 'react-router-dom'
import { Construction, ArrowLeft } from 'lucide-react'
import { ROUTES } from '@/constants/routes'

export function ComingSoon() {
  return (
    <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center">
      <div className="text-center">
        <Construction className="mx-auto mb-6 h-16 w-16 text-primary" />
        <h1 className="mb-4 text-3xl font-bold sm:text-4xl">Coming Soon</h1>
        <h2 className="mb-4 text-xl font-semibold text-muted-foreground">
          準備中
        </h2>
        <p className="mb-8 max-w-md text-muted-foreground">
          このデモは現在準備中です。<br />
          完成までしばらくお待ちください。
        </p>
        <Link
          to={ROUTES.PROJECTS}
          className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          <ArrowLeft className="h-4 w-4" />
          プロジェクト一覧に戻る
        </Link>
      </div>
    </div>
  )
}
